import {
  applyMiddleware,
  combineReducers,
  compose,
  createStore,
  Store
} from "redux";
import createSagaMiddleware from "redux-saga";
import applicationsReducer from "./reducers/applications";
import authReducer from "./reducers/auth";
import feedbackReducer from "./reducers/feedback";
import jobsReducer from "./reducers/jobs";
import reviewsReducer from "./reducers/reviews";
import statsReducer from "./reducers/stats";
import usersReducer from "./reducers/users";
import {
  watchAuth,
  watchDashboard,
  watchFeedback,
  watchJobs,
  watchReviews,
  watchUsers
} from "./sagas";

let isInitialized = false;
export function init(): Store<any> {
  if (isInitialized) {
    throw new Error("Store is already initialized.");
  }

  const composeEnhancers =
    process.env.NODE_ENV === "development"
      ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : null || compose;

  const rootReducer = combineReducers({
    stats: statsReducer,
    jobs: jobsReducer,
    applications: applicationsReducer,
    users: usersReducer,
    reviews: reviewsReducer,
    feedback: feedbackReducer,
    auth: authReducer
  });

  const sagaMiddleware = createSagaMiddleware();

  const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(sagaMiddleware))
  );

  // Watchers
  sagaMiddleware.run(watchDashboard);
  sagaMiddleware.run(watchJobs);
  sagaMiddleware.run(watchUsers);
  sagaMiddleware.run(watchFeedback);
  sagaMiddleware.run(watchReviews);
  sagaMiddleware.run(watchAuth);

  isInitialized = true;
  return store;
}



// WEBPACK FOOTER //
// ./src/store/index.ts